import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { provideNgIconLoader, withCaching } from '@ng-icons/core';

export const ICON_PROVIDERS = [
  provideNgIconLoader((name) => {
    const http = inject(HttpClient);
    return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
  }, withCaching()),
];
